exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".arrow-img{margin-left:3px;width:13px;height:13px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/less/sortArrow.less
// module id = 1645
// module chunks = 0